import React from "react";

function Footer() {
    return (
        <footer>
            <div className="container">
                <p>&copy; 2024 Dilruba Hub. All rights reserved. Created by Dildeep Singh</p>
                <p>Contact: <a href="mailto:dildeep@gabrhi.com">dildeep@gabrhi.com</a></p>
            </div>
        </footer>
    );
}

export default Footer;
